<div class="content">
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  <div class="inputRow">
    <mat-form-field class="selectionInput">
      <mat-label>{{ officeLabel }}</mat-label>
      <mat-select [(ngModel)]="input.organizationId" (ngModelChange)="loadOrganizationUsers()" [disabled]="isBusy()">
        @for (organization of organizations; track organization) {
          <mat-option [value]="organization.code">
            {{ organization.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <mat-form-field class="selectionInput">
      <mat-label>{{ userLabel }}</mat-label>
      <mat-select [(ngModel)]="input.notificationUser" [disabled]="isBusy()">
        @for (user of notificationUsers(); track user) {
          <mat-option [value]="user.code">
            {{ user.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <h4 class="notificationLabel">{{ notificationLabel }}</h4>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button (click)="cancel()" [disabled]="isBusy()" matButton="elevated" class="dialogButton warn-button">Cancel</button>
    <button (click)="save()" [disabled]="isBusy() || !canSave()" matButton="elevated" class="dialogButton primary-button">Save</button>
  </div>
</div>
